import { TSupplierFeature } from "@/http/types/supplier";

export const ANALYTICS_WIDGET_FEATURE_KEY = "ai.analytics.widget";

export function isFeatureEnabled(
  features: TSupplierFeature[] | undefined,
  key: string
): boolean {
  // No list or empty list from API: never treat flags as enabled (incl. analytics widget / super-agent).
  if (!features?.length) return false;
  const find = (
    items: TSupplierFeature[],
    k: string
  ): TSupplierFeature | undefined => {
    for (const item of items) {
      if (item.key === k) return item;
      if (item.children) {
        const found = find(item.children, k);
        if (found) return found;
      }
    }
    return undefined;
  };
  const feature = find(features, key);
  return feature?.enabled === true;
}
